import { useTranslations } from 'next-intl';

import Drawer from '@commons/components/Drawer';
import Text from '@commons/components/Text';
import BaseContainer from '@commons/containers/BaseContainer';

/**
 * ContactUsForm Header component.
 *
 * Only rendered if the form is in a drawer.
 */

const ContactUsFormHeader = () => {
  const t = useTranslations('forms.contactUs.header');

  return (
    <BaseContainer marginBottom="lg">
      <Drawer.Title asChild>
        <Text as="h2">{t('title')}</Text>
      </Drawer.Title>
      <Drawer.Description asChild>
        <Text level="body-lg">{t('description')}</Text>
      </Drawer.Description>
    </BaseContainer>
  );
};

export default ContactUsFormHeader;
